import { Program } from '@nemuru-eng/js-api-client';

import { Text } from '@/components/shared/components/Text';

export const getProgramSelectOptions = (availablePrograms: Program[]) =>
  availablePrograms.map((value) => ({
    value,
    display: <Text tId={value} />,
  }));
